import _ from 'lodash'
import $ from 'jquery'

export default {
	name : 'sort-field',
	props : ['data'],
	data () {
		return {			
			field : {								
				id: _.uniqueId('sort_'),							
				sort_default: true,
				sort_asc: false,
				sort_desc: false
			}
		}
	},
	methods : {		
		actionSort (event) {

			let vm = this;

			let target  = $(event.target).closest('#contrats_tr');			
			let iconIds = _.map(target.find('th').children('i'),'id');		

			_.each(iconIds, function(id){
			
				$('#' + id).removeClass("fa-sort-asc");
				$('#' + id).removeClass("fa-sort-desc");				
				$('#' + id).addClass("fa-sort");
				
			});

			if(vm.field.sort_default){
				vm.field.sort_default = false;				
				vm.field.sort_asc     = true;				
			} else			 
				if(vm.field.sort_asc){
					vm.field.sort_asc = false;				
					vm.field.sort_desc= true;
				} else
					if(vm.field.sort_desc){
						vm.field.sort_desc = false;				
						vm.field.sort_default = true;
					}
					
			this.$emit('changeData', this.field)

		}
	}
}


// WEBPACK FOOTER //
// ./src/components/general/fields/sort/script.js